import React from 'react';
import { ResetPWDContainer } from '../containers/resetpassword'

export default function ResetPWD() {
  return (
    <ResetPWDContainer />
  );
}